import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser
} from "@/components/signup/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils/get-rovo-dev-agents-logo";

import { PrivacyPolicy, WelcomeBackHeading } from "../../components";

export const LoggedInDevAIFreeExistingSitesUser = () => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedExistingUserSubHeader",
        defaultMessage: "Join the free beta program"
    });

    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <h1 css={headerCss}>
                <WelcomeBackHeading />
            </h1>
            <p css={headerCss}>{subHeaderText}</p>
            <SiteActivation
                ExistingUser={
                    <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
                }
                WeekOneUser={null}
                ManagedUser={null}
            />
        </SignupBackgroundLayout>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
